export default __webpack_public_path__ + "static/media/iicroom 2.ce747c74.jpg";